export const mapAndSortDescriptionAttributes = (
  descriptionAttributes: any[] | undefined | null,
  expandingAttributes: { key: string; translationKey?: string }[],
  productAttributesTranslations: Record<string, string>,
) => {
  if (!descriptionAttributes) return [];

  const translationMap = new Map(
    expandingAttributes.map((attr) => [attr.key, attr.translationKey]),
  );

  return descriptionAttributes
    .map((attribute) => ({
      ...attribute,
      displayName:
        productAttributesTranslations[
          translationMap.get(attribute.key) ?? attribute.displayName
        ] ?? attribute.displayName,
    }))
    .sort((a, b) => {
      const indexA = expandingAttributes.findIndex(
        (attr) => attr.key === a.key,
      );
      const indexB = expandingAttributes.findIndex(
        (attr) => attr.key === b.key,
      );

      if (indexA === -1 && indexB === -1) return 0;
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      return indexA - indexB;
    });
};
